import News from './news'
import Handbook from './handbook'
import Todos from './todos'
import Absence from './absence'
import Jubilees from './jubilees'
import People from './people'
// import Insights from './insights'

export const dashboardSections = {
    news: {
        title: {
            id: 'dashboard_news_heading',
            defaultMessage: 'Stay up to date'
        },
        component: News
    },
    handbook: {
        title: {
            id: 'handbooks_heading_pinned_topics',
            defaultMessage: 'Featured topics'
        },
        component: Handbook
    },
    todos: {
        title: {
            id: 'dashboard_todo_heading',
            defaultMessage: 'To-do list'
        },
        component: Todos
    },
    absence: {
        title: {
            id: 'dashboard_absence_heading',
            defaultMessage: 'Who’s away?'
        },
        component: Absence
    },
    jubilees: {
        title: {
            id: 'dashboard_jubilees_heading',
            defaultMessage: 'Jubilees'
        },
        component: Jubilees
    },
    people: {
        title: {
            id: 'people_heading_your_groups',
            defaultMessage: 'Your groups'
        },
        component: People
    }
}